import {ColumnStore} from "@bryntum/schedulerpro";
import {WIDGET_KEYS} from "../../other/constants/WidgetKeys.jsx";
import {
  columnAvatarConfig, columnAvatarString, EntityMainNameDefault, getCustomGroupRenderer, swivuGridSorterFn
} from "../../other/utils/utils.jsx";
import SwivuSortColumn from "./SwivuSortColumn.jsx";
import { STORE_KEYS } from "../../other/constants/StoreKeys.jsx";
import { EDITOR_KEYS } from "../../other/constants/EditorKeys.jsx";

export default class EligibleUserColumn extends SwivuSortColumn {
  static get fields() {
    return [
      { name: "swivuListTitle" },
      { name: "swivuListSearchKey", readOnly: true, defaultValue: "name" },
    ]
  }

  static get $name() {
    return "EligibleUserColumn";
  }

  static get type() {
    return WIDGET_KEYS.eligibleUserColumn;
  }

  static get defaults() {
    return {
      text: "Eligible Users",
      field: "eligibleUserValues",
      maxWidth: "40em",
      cellCls: "swivu-recipients-cell gap-[0.3em]",
      flex: 1,
      filterType: "_swivu_settings",
      htmlEncode: false,
      groupRenderer(e) {
        return getCustomGroupRenderer(e);
      },
      editor: false,
      tooltipRenderer: columnAvatarConfig.tooltipRenderer
    }
  }

  renderer({ value, record, grid }) {
    if (!record.isGroupHeader && this.project && value) {
      return record.eligibleBoardUserRecords.length ? record.eligibleBoardUserRecords.map((boardUserRecord) => {
        return columnAvatarConfig.columnAvatarRenderer({
          image: boardUserRecord.profileImageURL,
          name: boardUserRecord.name,
          size: grid.rowHeight,
          showName: false,
        });
      }) : EntityMainNameDefault()
    }
  }

  onLoad(project, { editorHandler }) {
    this.project = project;
    this.editorHandler = editorHandler;
  }

  get canMultiSelectSwivuList() {
    return true
  }

  get swivuListItems() {
    return this.project.getCrudStore(STORE_KEYS.boardUserStore).query((boardUser) => !boardUser.isDeactivated, true).sort(swivuGridSorterFn.bind({ field: "name" }));
  }

  getSwivuListItemDisplayValue(record) {
    return columnAvatarString(record.name, record.profileImageURL);
  }

  getSelectedSwivuListItem(record) {
    return record.eligibleBoardUsers;
  }

  onSwivuListSelectionChange(record, assignedBoardUsers) {
    record.eligibleBoardUsers = assignedBoardUsers.map(item => item.id);
  }

  onSwivuManageList() {
    const newRecord = this.project.boardUsersStore.createRecord();
    this.editorHandler.openEditor(EDITOR_KEYS.userEditor, newRecord, {
      user: newRecord
    })
  }
}

ColumnStore.registerColumnType(EligibleUserColumn);
